import { call, put, select, takeEvery } from "redux-saga/effects";
import Parse from "parse";
import {
  GET_CURRENT_USER,
  GET_OTP,
  LOGOUT_USER,
  VERIFY_OTP,
  VERIFY_USER,
} from "./constant";
import {
  getOTPError,
  getOTPLoading,
  getOTPSuccess,
  logoutUserError,
  logoutUserSuccess,
  verifyOTPError,
  verifyOTPLoading,
  verifyUser,
  verifyUserError,
  verifyUserSuccess,
} from "./actions";
import { APP_ID } from "../../utils/helpers";

function* getOTPMethod({ payload }) {
  try {
    yield put(getOTPLoading());
    const response = yield call(() =>
      Parse.Cloud.run("SendOTPv2", { phone: payload })
    );
    if (response) {
      yield put(getOTPSuccess({ phone: payload, otp: response }));
    }
  } catch (error) {
    yield put(getOTPError(error?.message || "Error occurred during get otp."));
  }
}

function* verifyOTPMethod({ payload }) {
  try {
    yield put(verifyOTPLoading());
    const response = yield call(() =>
      Parse.Cloud.run("AuthenticationV2", {
        phone: payload?.phone,
        otp: payload?.otp,
      })
    );
    if (response === "Invalid Otp") {
      yield put(verifyOTPError(response));
    } else if (!response) {
      yield put(verifyOTPError("User not found"));
    } else {
      const sessionToken = yield call(() => response[0].get("sessionToken"));
      if (sessionToken) {
        const token = yield call(() => Parse.User.become(sessionToken));
        if (token) {
          yield put(verifyUser(sessionToken));
        } else {
          yield call(() => Parse.User.logOut());
        }
      } else {
        yield put(verifyOTPError("Error occurred during verify OTP."));
      }
    }
  } catch (error) {
    yield put(
      verifyOTPError(error.message || "Error occurred during verify OTP.")
    );
  }
}

function* verifyUserMethod({ payload }) {
  try {
    const phone = yield select((state) => state.auth.userOTP.data?.phone);
    const customer = new Parse.Query("elearning_Customer");
    customer.equalTo("Mob_no", phone);
    customer.equalTo("AppId", {
      __type: "Pointer",
      className: "elearning_BuildConfig",
      objectId: APP_ID,
    });

    const response = yield call(() => customer.first());
    if (response) {
      localStorage.setItem("sessionToken", payload);
      yield put(verifyUserSuccess(JSON.parse(JSON.stringify(response))));
    } else {
      yield put(verifyUserError("Error occured during verify user"));
    }
  } catch (error) {
    yield put(
      verifyUserError(error?.message || "Error occurred during verify user.")
    );
  }
}

function* getCurrentUserMethod() {
  try {
    const currentUser = yield call(() => Parse.User.currentAsync());
    if (currentUser) {
      const customer = new Parse.Query("elearning_Customer");
      customer.equalTo("UserId", currentUser);
      customer.equalTo("AppId", {
        __type: "Pointer",
        className: "elearning_BuildConfig",
        objectId: APP_ID,
      });
      const response = yield call(() => customer.first());
      if (response) {
        yield put(verifyUserSuccess(JSON.parse(JSON.stringify(response))));
      } else {
        yield put(verifyUserError("Invalid session token"));
      }
    } else {
      yield put(verifyUserError("Invalid session token"));
    }
  } catch (error) {
    localStorage.clear();
    yield put(verifyUserError(error?.message || "Invalid session token"));
  }
}

function* logoutUserMethod() {
  try {
    const response = yield call(() => Parse.User.logOut());
    yield put(logoutUserSuccess(response));
  } catch (error) {
    yield put(
      logoutUserError(error?.message || "Error occurred during user logout.")
    );
  }
}

function* authSaga() {
  yield takeEvery(GET_OTP, getOTPMethod);
  yield takeEvery(VERIFY_OTP, verifyOTPMethod);
  yield takeEvery(VERIFY_USER, verifyUserMethod);
  yield takeEvery(GET_CURRENT_USER, getCurrentUserMethod);
  yield takeEvery(LOGOUT_USER, logoutUserMethod);
}

export default authSaga;
